import { HTMLAttributes, PropsWithChildren, ReactElement } from 'react'
import { IIconProps } from '../../../types/IconProps.interface'

export interface IIconButtonProps extends HTMLAttributes<HTMLButtonElement> {
  size?: 'md' | 'lg'
  children: ReactElement<PropsWithChildren<IIconProps>>
  className?: string
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
}

export const IconButton = ({
  children,
  onClick,
  size = 'md',
  className,
  disabled,
  type = 'button',
}: IIconButtonProps) => {
  return (
    <button
      className={`flex items-center justify-center rounded-[6px] bg-focus-100 shadow-outline shadow-focus/[0.65] outline-none transition-opacity duration-150 hover:shadow-default-500 ${size == 'md' ? 'h-[24px] w-[24px]' : 'h-[32px] w-[32px]'} ${disabled && 'pointer-events-none opacity-30'} ${className} `}
      disabled={disabled}
      type={type}
      onClick={onClick}
    >
      <span
        className={`flex items-center justify-center ${
          size == 'md' ? 'h-[8px] w-[8px]' : 'h-[15px] w-[15px]'
        }`}
      >
        {children}
      </span>
    </button>
  )
}
